(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .controller("SeminarLearnerAccessViewSeminarDetailsCtrl", ["seminar", "$scope", "frameworkService", seminarLearnerAccessViewSeminarDetailsCtrl]);
    function seminarLearnerAccessViewSeminarDetailsCtrl(seminar, $scope, frameworkService) {
        var vm = this;
        vm.singleLanguageSite = frameworkService.data.tenant.enabledLocalizations.length === 1;
        vm.seminar = seminar;
        vm.selectSeminar = function () {
            $scope.$close(vm.seminar);
        };
    }
}());
